// import _ from "lodash"
import filter from 'lodash/filter'
import forEachLodash from 'lodash/forEach'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import has from 'lodash/has'

async function applyRules(element, rules, source) {
  const rules_to_apply = filter(rules, { source: source.toString() })
  if (rules_to_apply.length > 0) {
    forEachLodash(rules_to_apply, function (rule) {
      if (rule.detail != undefined) {
        if (rule.type == 'translation') {
          element.detail = rule.detail
        }

        if (rule.type == 'status') {
          element.status_rule = rule.detail.active
        }

        if (rule.type == 'order') {
          element.order = rule.detail.order
        }
      }
    })
  }

  return element
}

async function getDesc(element, lang) {
  if (element == null) {
    return ''
  }

  const detail = element.detail != undefined ? element.detail : element

  let fallbackDesc_element = ''
  const desc_element = find(detail, { lang: lang })
  if (!desc_element) {
    fallbackDesc_element = find(detail, { lang: 'en' })
  }

  const fallBackLanguageCheck = element.detail != null ? element.detail : null
  let fallBackLanguage = null

  if (fallBackLanguageCheck != null && fallBackLanguageCheck.length > 0) {
    fallBackLanguage = fallBackLanguageCheck[0]
  }

  try {
    if (desc_element) {
      return decodeURIComponent(escape(desc_element.text))
    } else if (fallbackDesc_element) {
      console.log('Fallback trad.' + element.source)
      console.log(element)
      return decodeURIComponent(escape(fallbackDesc_element.text))
    } else if (fallBackLanguage != null) {
      return fallBackLanguage.text
    } else {
      console.log('Errore trad. ' + element.source)
      console.log(element)
      return element.source + '(n.t.)'
    }
  } catch (e) {
    console.log('error catch')

    if (desc_element) {
      return desc_element.text
    } else if (fallbackDesc_element) {
      console.log('Fallback trad.' + element.source)
      console.log(element)
      return fallbackDesc_element.text
    } else {
      console.log('Errore trad. ' + element.source)
      console.log(element)
      return element.source + '(n.t.)'
    }

    // console.log(e.message)
    // console.log(e.stack)
    // console.log(element)
  }
}

async function getTreeMultiplicity(
  tree_structure,
  rules,
  onlyManager,
  producer,
  market = 'all',
  treeMultiplicityDefault = undefined
) {
  try {
    let treeMultiplicity =
      treeMultiplicityDefault != undefined
        ? treeMultiplicityDefault
        : await getDefaultMultiplicity(rules, onlyManager, producer)
    // Level Sport
    const sportManagerMultiplicity = await filter(
      rules.manager,
      function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'sport#' + producer &&
          rule.source == tree_structure.sport.toString() &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      }
    )

    if (!onlyManager) {
      var sportSkinMultiplicity = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'sport#' + producer &&
          rule.source == tree_structure.sport.toString() &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      })
    }

    // Level Category
    const categoryManagerMultiplicity = await filter(
      rules.manager,
      function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'category#' + producer &&
          rule.source == tree_structure.category.toString() &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      }
    )

    if (!onlyManager) {
      var categorySkinMultiplicity = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'category#' + producer &&
          rule.source == tree_structure.category.toString() &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      })
    }

    // Level Tournament
    const tournamentManagerMultiplicity = await filter(
      rules.manager,
      function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'tournament#' + producer &&
          rule.source == tree_structure.tournament.toString() &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      }
    )

    if (!onlyManager) {
      var tournamentSkinMultiplicity = await filter(
        rules.skin,
        function (rule) {
          if (
            rule.type == 'multiplicity' &&
            rule.scope == 'tournament#' + producer &&
            rule.source == tree_structure.tournament.toString() &&
            rule.detail.market == market
          ) {
            return rule.detail.multiplicity
          }
        }
      )
    }

    if (
      tournamentSkinMultiplicity != undefined &&
      tournamentSkinMultiplicity.length == 1
    ) {
      treeMultiplicity = tournamentSkinMultiplicity[0].detail.multiplicity
    } else if (
      tournamentManagerMultiplicity != undefined &&
      tournamentManagerMultiplicity.length == 1
    ) {
      treeMultiplicity = tournamentManagerMultiplicity[0].detail.multiplicity
    } else if (
      categorySkinMultiplicity != undefined &&
      categorySkinMultiplicity.length == 1
    ) {
      treeMultiplicity = categorySkinMultiplicity[0].detail.multiplicity
    } else if (
      categoryManagerMultiplicity != undefined &&
      categoryManagerMultiplicity.length == 1
    ) {
      treeMultiplicity = categoryManagerMultiplicity[0].detail.multiplicity
    } else if (
      sportSkinMultiplicity != undefined &&
      sportSkinMultiplicity.length == 1
    ) {
      treeMultiplicity = sportSkinMultiplicity[0].detail.multiplicity
    } else if (
      sportManagerMultiplicity != undefined &&
      sportManagerMultiplicity.length == 1
    ) {
      treeMultiplicity = sportManagerMultiplicity[0].detail.multiplicity
    }

    return treeMultiplicity
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getDefaultMultiplicity(rules, onlyManager, producer) {
  try {
    const rule_default_manager = filter(rules.manager, function (rule) {
      if (rule.type == 'multiplicity' && rule.scope == 'default#' + producer) {
        return rule
      }
    })

    if (!onlyManager) {
      const rule_default_skin = filter(rules.skin, function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'default#' + producer
        ) {
          return rule
        }
      })

      if (rule_default_skin.length == 1) {
        return rule_default_skin[0].detail.multiplicity
      } else {
        return rule_default_manager[0].detail.multiplicity
      }
    } else {
      return rule_default_manager[0].detail.multiplicity
    }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function applyRulesToOdds(
  odds,
  eventSource,
  eventType,
  tree_structure,
  rules,
  onlyManager,
  producer,
  typeOdd,
  mode = 'preview'
) {
  try {
    //todo important check the keys for block a odd before close the feature !!!!!!!!!!!!!!!

    const oddsArray = []
    let odds_count = 0

    for (const odd of odds) {
      if (odd.odd_with_specifier == null || odd.odd_with_specifier == false) {
        // console.log('odd_with_specifier == null || odd.odd_with_specifier == false');

        const cleanSpecifier = odd.specifiers_parsed

        var id_market = odd._attributes.id
        let market_unique_id = odd._attributes.unique_id.toString()
        let status = '1'
        const marketObj =
          odd.detail != undefined ? odd.detail : odd._attributes.market
        const oddOutcomes = odd.outcome

        if (market_unique_id == undefined || market_unique_id == '') {
          market_unique_id =
            odd._attributes.specifiers != undefined &&
            odd._attributes.specifiers != ''
              ? id_market + '#' + odd._attributes.specifiers
              : id_market
        }

        const prefixOutcome = eventSource + ';' + market_unique_id + ';'

        const multiplicity = await getTreeMultiplicity(
          tree_structure,
          rules,
          onlyManager,
          producer,
          id_market.toString(),
          tree_structure.treeMultiplicity
        )
        const multiplicityEvent = await getEventMultiplicity(
          eventSource,
          rules,
          onlyManager,
          producer
        )
        const multiplicityMarketEvent = await getEventMultiplicity(
          eventSource,
          rules,
          onlyManager,
          producer,
          market_unique_id
        )

        const freeze_odds = await getEventFreeze(
          eventSource,
          rules,
          onlyManager,
          producer,
          market_unique_id
        )

        // console.log('freeze_odds old for market_unique_id: ' + market_unique_id);
        // console.log(freeze_odds);

        const key_from_rules = await getTreeKey(
          tree_structure,
          rules,
          onlyManager,
          producer,
          market_unique_id
        )
        const key_from_event = await getEventKey(
          eventSource,
          rules,
          onlyManager,
          producer,
          market_unique_id
        )
        let keyToApply = undefined

        if (key_from_event != undefined) {
          keyToApply = key_from_event
        } else if (key_from_rules != undefined) {
          keyToApply = key_from_rules
        }

        let multiplicity_with_rules = ''

        if (multiplicityMarketEvent != undefined) {
          multiplicity_with_rules = multiplicityMarketEvent
        } else if (multiplicityEvent != undefined) {
          multiplicity_with_rules = multiplicityEvent
        } else {
          multiplicity_with_rules = multiplicity
        }

        var split_multi = multiplicity_with_rules.split('-')
        const multiplicity_min = split_multi[0]
        const multiplicity_max = split_multi[1]

        //console.log(marketObject)
        if (status == null) {
          // console.log('status is null');

          var marketObject = {
            id_market: id_market,
            unique_id: market_unique_id,
            multiplicity: multiplicity_with_rules,
            multiplicity_min: multiplicity_min,
            multiplicity_max: multiplicity_max,
            n_outcomes: oddOutcomes.length,
            void: true,
            active: false,
            odds: {},
          }
          if (odd.sorted) {
            marketObject.sorted = odd.sorted
          }
          oddsArray.push(marketObject)
        } else {
          // console.log('status is NOT null');

          const rules_disabled = {
            manager: filter(rules.manager, {
              type: 'disable',
              scope: 'event',
              source: eventSource.toString(),
            }),
            skin: filter(rules.skin, {
              type: 'disable',
              scope: 'event',
              source: eventSource.toString(),
            }),
          }

          if (
            rules_disabled.manager.length > 0 ||
            rules_disabled.skin.length > 0
          ) {
            status = await getStatusFromRule(
              market_unique_id,
              rules_disabled,
              'market'
            )
            if (!status) {
              const marketObject = {
                id_market: id_market,
                unique_id: market_unique_id,
                multiplicity: multiplicity_with_rules,
                multiplicity_min: multiplicity_min,
                multiplicity_max: multiplicity_max,
                n_outcomes: oddOutcomes.length,
                void: true,
                active: false,
                odds: {},
              }
              if (odd.sorted) {
                marketObject.sorted = odd.sorted
              }
              oddsArray.push(marketObject)
              continue
            }
          }

          if (freeze_odds != undefined) {
            var desc_market = find(marketObj, { lang: rules.lang })
            if (!desc_market) {
              desc_market = find(marketObj, { lang: 'en' })
            }

            freeze_odds.name_market = desc_market
              ? desc_market.text
              : 'Market non tradotto'

            for (const outcome of oddOutcomes) {
              var id_outcome = outcome._attributes
                ? outcome._attributes.id
                : outcome.id

              if (outcome == null) {
                console.log('###ERROR: outcome market_id: ' + id_market)
              } else {
                if (
                  outcome.detail == undefined ||
                  outcome.detail == null ||
                  outcome.detail.length == 0
                ) {
                  var desc_outcome_name = undefined
                } else {
                  var desc_outcome_name = find(outcome.detail, {
                    lang: rules.lang,
                  })
                  if (!desc_outcome_name) {
                    console.log('Fallback English Outcome')
                    console.log(outcome)
                    desc_outcome_name = find(outcome.detail, { lang: 'en' })
                  }
                }

                const outcomeToFind = find(freeze_odds.odds, {
                  id_outcome: id_outcome,
                })
                outcomeToFind.outcome_name = desc_outcome_name
                  ? desc_outcome_name.text
                  : outcome.alias
              }
            }

            var marketObject = {
              ...freeze_odds,
            }

            oddsArray.push(marketObject)

            continue
          }

          const oddsMarket = []
          let keyPercent = 0.0
          let odds_total = 0.0
          var id_market = id_market
          const specifier =
            odd._attributes.specifiers != undefined
              ? odd._attributes.specifiers
              : 'not_spec'

          var desc_market = find(marketObj, { lang: rules.lang })
          if (!desc_market) {
            desc_market = find(marketObj, { lang: 'en' })
          }

          if (
            oddOutcomes != undefined &&
            oddOutcomes != null &&
            oddOutcomes.length > 0
          ) {
            // Variable to show or not Market
            var exitsOdds = false
            var odds_count_market = oddOutcomes.length

            for (const outcome_to_sum of oddOutcomes) {
              if (
                outcome_to_sum != null &&
                outcome_to_sum._attributes != undefined &&
                outcome_to_sum._attributes.odds != undefined &&
                outcome_to_sum._attributes.odds != '0.00'
              ) {
                odds_total += parseFloat(outcome_to_sum._attributes.odds)
                odds_count++
              }
            }

            for (const outcome of oddOutcomes) {
              // console.log('outcome')
              // console.log(outcome)
              // console.log('******')
              const status_outcome =
                outcome._attributes != undefined &&
                outcome._attributes.status == 1

              if (
                rules_disabled.manager.length > 0 ||
                rules_disabled.skin.length > 0
              ) {
                var status_outcome_rules = await getStatusFromRule(
                  outcome.unique_id,
                  rules_disabled,
                  'outcome'
                )
              } else {
                var status_outcome_rules = true
              }

              if (outcome == null) {
                console.log('##ERRORE: outcome market_id: ' + id_market)
              } else {
                var id_outcome = outcome._attributes
                  ? outcome._attributes.id
                  : outcome.id

                if (outcome.unique_id != undefined && outcome.unique_id != '') {
                  var outcome_unique_id = outcome.unique_id
                } else {
                  var outcome_unique_id = prefixOutcome + id_outcome
                }

                if (
                  outcome.detail == undefined ||
                  outcome.detail == null ||
                  outcome.detail.length == 0
                ) {
                  var desc_outcome_name = undefined
                } else {
                  var desc_outcome_name = find(outcome.detail, {
                    lang: rules.lang,
                  })
                  if (!desc_outcome_name) {
                    console.log('Fallback Inglese Outcome')
                    console.log(outcome)
                    desc_outcome_name = find(outcome.detail, { lang: 'en' })
                  }
                }
                const marketFixed =
                  outcome._attributes &&
                  outcome._attributes.hasOwnProperty('fixed')
                    ? outcome._attributes.fixed
                    : 0
                //console.log(marketFixed)
                // if (status_outcome && outcome._attributes != undefined && outcome._attributes.odds != undefined && outcome._attributes.odds != 0.00 && outcome._attributes.odds >= 1.01 && status_outcome_rules) {
                if (
                  outcome != null &&
                  outcome._attributes != undefined &&
                  outcome._attributes.odds != undefined &&
                  outcome._attributes.odds != '0.00'
                ) {
                  const key_value = 100 / parseFloat(outcome._attributes.odds)
                  const odd_percent =
                    (parseFloat(outcome._attributes.odds) * 100) / odds_total

                  var oddObject = {
                    id_market: id_market,
                    market_unique_id: market_unique_id,
                    market_name: desc_market
                      ? desc_market.text
                      : 'Market non tradotto',
                    id_outcome: id_outcome,
                    unique_id: outcome_unique_id,
                    outcome_alias: outcome.alias,
                    ext_id: outcome._attributes.external_id,
                    outcome_name: desc_outcome_name
                      ? desc_outcome_name.text
                      : outcome.alias,
                    outcome_odd_value: parseFloat(
                      outcome._attributes.odds
                    ).toFixed(2),
                    outcome_odd_value_original: parseFloat(
                      outcome._attributes.odds
                    ).toFixed(2),
                    outcome_odd_percent: parseFloat(odd_percent).toFixed(2),
                    outcome_odd_percent_original:
                      parseFloat(odd_percent).toFixed(2),
                    outcome_key_value: key_value,
                    outcome_key_value_original: key_value,
                    outcome_odd_value_for_order: parseFloat(
                      outcome._attributes.odds
                    ),
                    active:
                      status == '1' &&
                      status_outcome &&
                      status_outcome_rules &&
                      outcome._attributes.odds >= 1.01,
                    multiplicity: multiplicity_with_rules,
                    multiplicity_min: multiplicity_min,
                    multiplicity_max: multiplicity_max,
                    market_fixed: marketFixed,
                    spec: cleanSpecifier ? cleanSpecifier : '',
                    type: typeOdd,
                    specifier:
                      outcome.specifier != null ? outcome.specifier : '',
                  }
                  if (odd.sorted) {
                    oddObject.sorted = odd.sorted
                  }
                  keyPercent += key_value

                  exitsOdds = true
                } else {
                  var oddObject = {
                    id_market: id_market,
                    market_unique_id: market_unique_id,
                    market_name: desc_market
                      ? desc_market.text
                      : 'Market non tradotto',
                    id_outcome: id_outcome,
                    unique_id: outcome_unique_id,
                    outcome_alias: outcome.alias,
                    outcome_name: desc_outcome_name
                      ? desc_outcome_name.text
                      : outcome.alias,
                    outcome_odd_value: 'lock',
                    outcome_odd_value_for_order: 999999999999999,
                    outcome_key_value: 0,
                    active: false,
                    multiplicity: multiplicity_with_rules,
                    multiplicity_min: multiplicity_min,
                    multiplicity_max: multiplicity_max,
                    type: typeOdd,
                    market_fixed: marketFixed,
                    spec: cleanSpecifier ? cleanSpecifier : '',
                    specifier:
                      outcome.specifier != null ? outcome.specifier : '',
                  }
                  if (odd.sorted) {
                    oddObject.sorted = odd.sorted
                  }
                }

                oddsMarket.push(oddObject)
              }
            }
          }

          // if (keyToApply == undefined && keyPercent < 105) {
          //     keyToApply = 105
          // }

          // Forzo la key
          if (keyToApply != undefined) {
            const key_percent_original = keyPercent
            const key_percent_fixed_original = parseFloat(keyPercent).toFixed(0)
            const odds_total_original = odds_total
            const newkey = parseFloat(keyToApply).toFixed(0)

            keyPercent = parseFloat(keyToApply).toFixed(0)
            odds_total = (odds_total_original * key_percent_original) / newkey

            for (const odd of oddsMarket) {
              if (odd.outcome_odd_value != 'lock' && odd.market_fixed == 0) {
                const new_odd_value =
                  (odd.outcome_odd_percent * odds_total) / 100
                odd.active =
                  odd.active && parseFloat(new_odd_value.toFixed(2)) > 1.01
                odd.outcome_odd_value_original = odd.outcome_odd_value
                odd.outcome_odd_value = new_odd_value.toFixed(2)
                odd.outcome_key_value_original = odd.outcome_key_value
                odd.outcome_key_value = 100 / odd.outcome_odd_value
                odd.outcome_odd_percent_original = odd.outcome_odd_percent
                odd.outcome_odd_value_for_order = parseFloat(
                  new_odd_value.toFixed(2)
                )
              }
            }

            var split_multi = multiplicity_with_rules.split('-')
            var specifier_id = specifier
            if (specifier.includes(':')) {
              var split_spec = specifier.split(':')
            }
            var marketObject = {
              id_market: id_market,
              unique_id: market_unique_id,
              multiplicity: multiplicity_with_rules,
              multiplicity_min: multiplicity_min,
              multiplicity_max: multiplicity_max,
              void: false,
              name_market: desc_market
                ? desc_market.text
                : 'Market non tradotto',
              specifiers: specifier,
              // specifier_id: (split_spec != undefined)? +split_spec[split_spec.length-1] : specifier_id,
              odds:
                eventType != 'match' &&
                oddsMarket.length >= 4 &&
                mode == 'detail'
                  ? orderBy(
                      oddsMarket,
                      ['outcome_odd_value_for_order'],
                      ['asc']
                    )
                  : oddsMarket,
              odds_total: odds_total,
              odds_total_original: odds_total,
              key_from_rules: keyToApply,
              key_percent: keyPercent,
              key_percent_original: keyPercent,
              key_percent_fixed: parseFloat(keyPercent).toFixed(0),
              key_percent_fixed_original: parseFloat(keyPercent).toFixed(0),
              key_locked: true,
              override: true,
              showMarket: exitsOdds,
              freeze: false,
              active: status == '1',
              odds_count_market: odds_count_market,
              showLocked: odds_count_market <= 8,
              spec: cleanSpecifier ? cleanSpecifier : '',
            }
            if (odd.sorted) {
              marketObject.sorted = odd.sorted
            }

            if (typeOdd === 'live') {
              marketObject.marketLivePreviewSort = odd.marketSort
              marketObject.specifierLivePreviewSort = odd.liveSpecifierSort
            }
          } else {
            var split_multi = multiplicity_with_rules.split('-')
            var specifier_id = specifier
            if (specifier.includes(':')) {
              var split_spec = specifier.split(':')
            }

            var marketObject = {
              id_market: id_market,
              unique_id: market_unique_id,
              multiplicity: multiplicity_with_rules,
              multiplicity_min: multiplicity_min,
              multiplicity_max: multiplicity_max,
              void: false,
              name_market: desc_market
                ? desc_market.text
                : 'Market non tradotto',
              specifiers: specifier,
              // specifier_id: (split_spec != undefined)? +split_spec[split_spec.length-1] : specifier_id,
              odds:
                eventType != 'match' &&
                oddsMarket.length >= 4 &&
                mode == 'detail'
                  ? orderBy(
                      oddsMarket,
                      ['outcome_odd_value_for_order'],
                      ['asc']
                    )
                  : oddsMarket,
              odds_total: odds_total,
              odds_total_original: odds_total,
              key_from_rules: key_from_rules,
              key_percent: keyPercent,
              key_percent_original: keyPercent,
              key_percent_fixed: parseFloat(keyPercent).toFixed(0),
              key_percent_fixed_original: parseFloat(keyPercent).toFixed(2),
              key_locked: false,
              override: false,
              showMarket: exitsOdds,
              freeze: false,
              active: status == '1',
              odds_count_market: odds_count_market,
              showLocked: odds_count_market <= 8,
              spec: cleanSpecifier ? cleanSpecifier : '',
            }
            if (odd.sorted) {
              marketObject.sorted = odd.sorted
            }

            if (typeOdd === 'live') {
              marketObject.marketLivePreviewSort = odd.marketSort
              marketObject.specifierLivePreviewSort = odd.liveSpecifierSort
            }
          }

          oddsArray.push(marketObject)
        }
      } else {
        const marketObject = await buildMarketObjectForMarketWithSpecifiers(
          odd,
          eventSource,
          eventType,
          tree_structure,
          rules,
          onlyManager,
          producer,
          typeOdd,
          mode
        )
        oddsArray.push(marketObject)
      }
    }

    await applySort(oddsArray)
    return { oddsArray: oddsArray, count_odds: odds_count }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function buildMarketObjectForMarketWithSpecifiers(
  odd,
  eventSource,
  eventType,
  tree_structure,
  rules,
  onlyManager,
  producer,
  typeOdd,
  mode = 'preview'
) {
  const multiplicityEvent = await getEventMultiplicity(
    eventSource,
    rules,
    onlyManager,
    producer
  )
  // console.log('odd with specifiers ')

  const cleanSpecifier = odd.specifiers_parsed

  const oddsMarket = []

  const id_market = odd.outcome[0].marketInfo.id
  // console.log('buildMarketObjectForMarketWithSpecifiers function for marketUniqueId' + id_market)
  const marketObj =
    odd.detail != undefined ? odd.detail : odd.outcome[0].marketInfo.market
  let desc_market = find(marketObj, { lang: rules.lang })
  if (!desc_market) {
    desc_market = find(marketObj, { lang: 'en' })
  }

  const marketUniqueIdSet = new Set()
  const mapMarketUniqueIdOutcomes = new Map()
  const mapMarketUniqueIdKeyPercent = new Map()
  const mapMarketUniqueIdFreezeOdds = new Map()

  const key_from_rules_map = new Map()
  const key_from_events_map = new Map()
  const multiplicityMarketEventMap = new Map()
  const statusFromRuleMarketUniqueIdMap = new Map()
  const multiplicityTreeMap = new Map()

  for (let i = 0; i < odd.outcome.length; i++) {
    marketUniqueIdSet.add(odd.outcome[i].marketInfo.unique_id)
  }

  const rules_disabled = {
    manager: filter(rules.manager, {
      type: 'disable',
      scope: 'event',
      source: eventSource.toString(),
    }),
    skin: filter(rules.skin, {
      type: 'disable',
      scope: 'event',
      source: eventSource.toString(),
    }),
  }

  for (const marketUniqueId of marketUniqueIdSet.values()) {
    const key_from_rules = await getTreeKey(
      tree_structure,
      rules,
      onlyManager,
      producer,
      marketUniqueId.toString()
    )
    key_from_rules_map.set(marketUniqueId.toString(), key_from_rules)

    const key_from_event = await getEventKey(
      eventSource,
      rules,
      onlyManager,
      producer,
      marketUniqueId.toString()
    )
    key_from_events_map.set(marketUniqueId.toString(), key_from_event)

    const multiplicityMarketEvent = await getEventMultiplicity(
      eventSource,
      rules,
      onlyManager,
      producer,
      marketUniqueId.toString()
    )
    multiplicityMarketEventMap.set(
      marketUniqueId.toString(),
      multiplicityMarketEvent
    )

    const outcomesOfThisMarketUniqueId = odd.outcome.filter(outcome => {
      return outcome.marketInfo.unique_id == marketUniqueId
    })

    // create map marketUniqueId - keyPercent
    let keyPercent = 0.0

    for (const outcome of outcomesOfThisMarketUniqueId) {
      // console.log('marketInfo')
      // console.log(outcome.marketInfo.id)
      if (outcome._attributes != null && outcome._attributes.odds != null) {
        keyPercent += 100 / parseFloat(outcome._attributes.odds)
      }
    }
    mapMarketUniqueIdKeyPercent.set(marketUniqueId, keyPercent)

    mapMarketUniqueIdOutcomes.set(marketUniqueId, outcomesOfThisMarketUniqueId)

    const freeze_odds = await getEventFreeze(
      eventSource,
      rules,
      onlyManager,
      producer,
      marketUniqueId
    )
    mapMarketUniqueIdFreezeOdds.set(marketUniqueId, freeze_odds)
  }

  for (let i = 0; i < odd.outcome.length; i++) {
    let market_unique_id = odd.outcome[i].marketInfo.unique_id.toString()
    let status = '1'

    if (market_unique_id == undefined || market_unique_id == '') {
      market_unique_id =
        odd.outcome[i].marketInfo.specifiers != undefined &&
        odd.outcome[i].marketInfo.specifiers != ''
          ? id_market + '#' + odd.outcome[i].marketInfo.specifiers
          : id_market
    }

    const prefixOutcome = eventSource + ';' + market_unique_id + ';'

    let multiplicity = multiplicityTreeMap.get(id_market.toString()) //todo move out of this cycle for
    if (multiplicity == null) {
      multiplicity = await getTreeMultiplicity(
        tree_structure,
        rules,
        onlyManager,
        producer,
        id_market.toString(),
        tree_structure.treeMultiplicity
      )
      multiplicityTreeMap.set(id_market.toString(), multiplicity)
    }

    const multiplicityMarketEvent =
      multiplicityMarketEventMap.get(market_unique_id)

    let multiplicity_with_rules = ''

    if (multiplicityMarketEvent != undefined) {
      multiplicity_with_rules = multiplicityMarketEvent
    } else if (multiplicityEvent != undefined) {
      multiplicity_with_rules = multiplicityEvent
    } else {
      multiplicity_with_rules = multiplicity
    }

    const split_multi = multiplicity_with_rules.split('-')
    const multiplicity_min = split_multi[0]
    const multiplicity_max = split_multi[1]

    // TODO TEST Market rules on scope market and outcome before close the feature !!!
    if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
      status = statusFromRuleMarketUniqueIdMap.get(market_unique_id)
      if (status == null) {
        status = await getStatusFromRule(
          market_unique_id,
          rules_disabled,
          'market'
        )
        statusFromRuleMarketUniqueIdMap.set(market_unique_id, status)
      }
    }

    const status_outcome =
      odd.outcome[i]._attributes != undefined &&
      odd.outcome[i]._attributes.status == 1
    let status_outcome_rules = true

    if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
      status_outcome_rules = await getStatusFromRule(
        odd.outcome[i].unique_id,
        rules_disabled,
        'outcome'
      )
    }

    let oddObject = {}
    const id_outcome = odd.outcome[i]._attributes
      ? odd.outcome[i]._attributes.id
      : odd.outcome[i].id

    let outcome_unique_id = prefixOutcome + id_outcome
    if (
      odd.outcome[i].unique_id != undefined &&
      odd.outcome[i].unique_id != ''
    ) {
      outcome_unique_id = odd.outcome[i].unique_id
    }

    let desc_outcome_name = undefined
    if (odd.outcome[i].detail != null && odd.outcome[i].detail.length > 0) {
      desc_outcome_name = find(odd.outcome[i].detail, { lang: rules.lang })
      if (!desc_outcome_name) {
        console.log('Fallback Inglese Outcome')
        console.log(odd.outcome[i])
        desc_outcome_name = find(odd.outcome[i].detail, { lang: 'en' })
      }
    }

    const marketFixed =
      odd.outcome[i]._attributes &&
      odd.outcome[i]._attributes.hasOwnProperty('fixed')
        ? odd.outcome[i]._attributes.fixed
        : 0

    const freeze_odds = mapMarketUniqueIdFreezeOdds.get(market_unique_id)
    let freeze_odd = null

    if (freeze_odds != null) {
      // console.log('freeze_odds != null')

      const freeze_odd_found = freeze_odds.odds.filter(oddFreezed => {
        return oddFreezed.unique_id == odd.outcome[i].unique_id
      })

      if (freeze_odd_found.length > 0) {
        freeze_odd = freeze_odd_found[0]

        console.log('Freezed Odd found is: ')
        console.log(freeze_odd)

        oddObject = {
          id_market: freeze_odd.id_market,
          market_unique_id: freeze_odd.market_unique_id,
          market_name: freeze_odd.market_name
            ? freeze_odd.market_name
            : 'Market non translated',
          id_outcome: freeze_odd.id_outcome,
          unique_id: freeze_odd.unique_id,
          outcome_alias: freeze_odd.outcome_alias,
          ext_id: freeze_odd.ext_id,
          outcome_name: freeze_odd.outcome_name
            ? freeze_odd.outcome_name
            : odd.outcome[i].alias,
          outcome_odd_value: parseFloat(freeze_odd.outcome_odd_value).toFixed(
            2
          ),
          outcome_odd_value_original: parseFloat(
            freeze_odd.outcome_odd_value_original
          ).toFixed(2),
          outcome_odd_percent: parseFloat(
            freeze_odd.outcome_odd_percent
          ).toFixed(2),
          outcome_odd_percent_original: parseFloat(
            freeze_odd.outcome_odd_percent_original
          ).toFixed(2),
          outcome_key_value: freeze_odd.outcome_key_value,
          outcome_key_value_original: freeze_odd.outcome_key_value_original,
          outcome_odd_value_for_order: parseFloat(
            freeze_odd.outcome_odd_value_for_order
          ),
          active:
            status == '1' &&
            status_outcome &&
            status_outcome_rules &&
            parseFloat(freeze_odd.outcome_odd_value).toFixed(2) >= 1.01,
          multiplicity: freeze_odd.multiplicity,
          multiplicity_min: freeze_odd.multiplicity_min,
          multiplicity_max: freeze_odd.multiplicity_max,
          market_fixed: marketFixed,
          spec: cleanSpecifier ? cleanSpecifier : '',
          type: typeOdd,
          specifier:
            odd.outcome[i].specifier != null ? odd.outcome[i].specifier : '',
        }
      } else {
        console.log(
          'error taking info from freeze_odds for unique_id : ' +
            odd.outcome[i].unique_id
        )
      }
    } else {
      if (
        odd.outcome[i] != null &&
        odd.outcome[i]._attributes != undefined &&
        odd.outcome[i]._attributes.odds != undefined &&
        odd.outcome[i]._attributes.odds != '0.00'
      ) {
        const key_value = 100 / parseFloat(odd.outcome[i]._attributes.odds)
        const odd_percent =
          (parseFloat(odd.outcome[i]._attributes.odds) * 100) /
          calculateSumOdds(mapMarketUniqueIdOutcomes, market_unique_id)

        oddObject = {
          id_market: id_market,
          market_unique_id: market_unique_id,
          market_name: desc_market ? desc_market.text : 'Market not translated',
          id_outcome: id_outcome,
          unique_id: outcome_unique_id,
          outcome_alias: odd.outcome[i].alias,
          ext_id: odd.outcome[i]._attributes.external_id,
          outcome_name: desc_outcome_name
            ? desc_outcome_name.text
            : odd.outcome[i].alias,
          outcome_odd_value: parseFloat(
            odd.outcome[i]._attributes.odds
          ).toFixed(2),
          outcome_odd_value_original: parseFloat(
            odd.outcome[i]._attributes.odds
          ).toFixed(2),
          outcome_odd_percent: parseFloat(odd_percent).toFixed(2),
          outcome_odd_percent_original: parseFloat(odd_percent).toFixed(2),
          outcome_key_value: key_value,
          outcome_key_value_original: key_value,
          outcome_odd_value_for_order: parseFloat(
            odd.outcome[i]._attributes.odds
          ),
          active:
            status == '1' &&
            status_outcome &&
            status_outcome_rules &&
            odd.outcome[i]._attributes.odds >= 1.01,
          multiplicity: multiplicity_with_rules,
          multiplicity_min: multiplicity_min,
          multiplicity_max: multiplicity_max,
          market_fixed: marketFixed,
          spec: cleanSpecifier ? cleanSpecifier : '',
          type: typeOdd,
          specifier:
            odd.outcome[i].specifier != null ? odd.outcome[i].specifier : '',
        }

        if (odd.sorted) {
          oddObject.sorted = odd.sorted
        }
        // exitsOdds = true
      } else {
        oddObject = {
          id_market: id_market,
          market_unique_id: market_unique_id,
          market_name: desc_market ? desc_market.text : 'Market not translated',
          id_outcome: id_outcome,
          unique_id: outcome_unique_id,
          outcome_alias: odd.outcome[i].alias,
          outcome_name: desc_outcome_name
            ? desc_outcome_name.text
            : odd.outcome[i].alias,
          outcome_odd_value: 'lock',
          outcome_odd_value_for_order: 999999999999999,
          outcome_key_value: 0,
          active: false,
          multiplicity: multiplicity_with_rules,
          multiplicity_min: multiplicity_min,
          multiplicity_max: multiplicity_max,
          type: typeOdd,
          market_fixed: marketFixed,
          spec: cleanSpecifier ? cleanSpecifier : '',
          specifier:
            odd.outcome[i].specifier != null ? odd.outcome[i].specifier : '',
        }
        if (odd.sorted) {
          oddObject.sorted = odd.sorted
        }
      }

      //force key !!!
      const key_from_rules = key_from_rules_map.get(market_unique_id)
      const key_from_event = key_from_events_map.get(market_unique_id)
      let keyToApply = undefined

      // console.log('key_from_rules for marketUniqueId: '+ market_unique_id)
      // console.log(key_from_rules)
      //
      // console.log('key_from_event: for marketUniqueId'+ market_unique_id)
      // console.log(key_from_event)

      let keyPercent = mapMarketUniqueIdKeyPercent.get(market_unique_id)

      if (key_from_event != undefined) {
        // console.log('key_from_event != undefined')
        keyToApply = key_from_event
      } else if (key_from_rules != undefined) {
        // console.log('key_from_rules != undefined')
        keyToApply = key_from_rules
      }

      // if (keyToApply == undefined && keyPercent < 105) {
      //     keyToApply = 105
      // }

      // console.log('key to apply is ')
      // console.log(keyToApply)

      let odds_total = 0.0

      if (keyToApply != undefined) {
        // console.log('key to apply for the market unique id: ' + market_unique_id + ' is:  ')
        // console.log(keyToApply);

        const key_percent_original = keyPercent
        const key_percent_fixed_original = parseFloat(keyPercent).toFixed(0)
        const odds_total_original = calculateSumOdds(
          mapMarketUniqueIdOutcomes,
          market_unique_id
        )
        const newkey = parseFloat(keyToApply).toFixed(0)

        keyPercent = parseFloat(keyToApply).toFixed(0)
        odds_total = (odds_total_original * key_percent_original) / newkey

        if (
          oddObject.outcome_odd_value != 'lock' &&
          oddObject.market_fixed == 0
        ) {
          const new_odd_value =
            (oddObject.outcome_odd_percent * odds_total) / 100
          oddObject.active =
            oddObject.active && parseFloat(new_odd_value.toFixed(2)) > 1.01
          oddObject.outcome_odd_value_original = oddObject.outcome_odd_value
          oddObject.outcome_odd_value = new_odd_value.toFixed(2)
          oddObject.outcome_key_value_original = oddObject.outcome_key_value
          oddObject.outcome_key_value = 100 / oddObject.outcome_odd_value
          oddObject.outcome_odd_percent_original = oddObject.outcome_odd_percent
          oddObject.outcome_odd_value_for_order = parseFloat(
            new_odd_value.toFixed(2)
          )
        }
      }
    }

    oddsMarket.push(oddObject)

    // oddsArray.push(marketObject)
  }

  const marketObject = {
    id_market: id_market,
    void: false,
    name_market: desc_market ? desc_market.text : 'Market not translated',
    odds: oddsMarket,
    // odds_total: odds_total, // todo
    // odds_total_original: odds_total, // todo
    freeze: false, //todo
    // active: (status == '1'), // todo
    // odds_count_market: odds_count_market,
    // showLocked: (odds_count_market <= 8),
    spec: cleanSpecifier ? cleanSpecifier : '',
    selectView: true,
    outcomeNumbersForSpread: odd.outcomeNumbersForSpread,
  }

  if (odd.sorted) {
    marketObject.sorted = odd.sorted
  }

  return marketObject
}

function calculateSumOdds(mapMarketsUniqueIdOutcomes, marketUniqueId) {
  const outcomes = mapMarketsUniqueIdOutcomes.get(marketUniqueId)
  let odds_total = 0.0

  for (let i = 0; i < outcomes.length; i++) {
    if (
      outcomes[i] != null &&
      outcomes[i]._attributes != undefined &&
      outcomes[i]._attributes.odds != undefined &&
      outcomes[i]._attributes.odds != '0.00'
    ) {
      odds_total += parseFloat(outcomes[i]._attributes.odds)
    }
  }

  return odds_total
}

function calculateOutcomesNumber(mapMarketsUniqueIdOutcomes, marketUniqueId) {
  const outcomes = mapMarketsUniqueIdOutcomes.get(marketUniqueId)
  return outcomes.length
}

async function applySort(odds) {
  if (odds.length > 0) {
    const markets = _.groupBy(odds, 'id_market')

    for (const [key, value] of Object.entries(markets)) {
      //   console.log("1",value)
      _.orderBy(value, ['sorted', 'specifiers'], ['asc', 'asc'])
      //   console.log("2",value)
    }
  }
}

async function refreshOdds(oddsMarkets, mode = 'preview') {
  try {
    await Promise.all(
      Object.keys(oddsMarkets).map(async index => {
        const market = oddsMarkets[index]

        if (
          !market.freeze &&
          market.has_to_update != undefined &&
          market.has_to_update == true
        ) {
          market.active = true

          let odds_total = 0.0
          let keyPercent = 0.0

          for (const outcome_to_sum of market.odds) {
            outcome_to_sum.active =
              outcome_to_sum.outcome_status_to_refresh != undefined
                ? outcome_to_sum.outcome_status_to_refresh
                : outcome_to_sum.active
            if (outcome_to_sum != null && outcome_to_sum.active) {
              odds_total += parseFloat(outcome_to_sum.outcome_value_to_refresh)
            }
          }

          await Promise.all(
            market.odds.map(async outcome => {
              if (outcome.has_to_update) {
                if (
                  outcome.outcome_value_to_refresh != undefined &&
                  +outcome.outcome_odd_value !=
                    +outcome.outcome_value_to_refresh
                ) {
                  outcome.outcome_odd_value_backup = outcome.outcome_odd_value

                  let change = 'equal'
                  if (
                    parseFloat(outcome.outcome_value_to_refresh) >
                    parseFloat(outcome.outcome_odd_value)
                  ) {
                    change = 'up'
                  } else if (
                    parseFloat(outcome.outcome_value_to_refresh) <
                    parseFloat(outcome.outcome_odd_value)
                  ) {
                    change = 'down'
                  }

                  outcome.type_change = change

                  const key_value =
                    100 / parseFloat(outcome.outcome_value_to_refresh)
                  const odd_percent =
                    (parseFloat(outcome.outcome_value_to_refresh) * 100) /
                    odds_total

                  outcome.outcome_odd_value = parseFloat(
                    outcome.outcome_value_to_refresh
                  ).toFixed(2)
                  outcome.outcome_odd_value_original = parseFloat(
                    outcome.outcome_value_to_refresh
                  ).toFixed(2)
                  outcome.outcome_odd_percent =
                    parseFloat(odd_percent).toFixed(2)
                  outcome.outcome_odd_percent_original =
                    parseFloat(odd_percent).toFixed(2)
                  outcome.outcome_odd_value_for_order = parseFloat(
                    outcome.outcome_value_to_refresh
                  )
                  outcome.active =
                    parseFloat(outcome.outcome_value_to_refresh) < 1.01
                      ? false
                      : outcome.active
                  keyPercent += key_value
                }
              }
            })
          )

          if (market.override && market.key_locked) {
            const key_percent_original = keyPercent
            const key_percent_fixed_original = parseFloat(keyPercent).toFixed(0)
            const odds_total_original = odds_total
            const newkey = parseFloat(market.key_from_rules).toFixed(0)

            keyPercent = parseFloat(market.key_from_rules).toFixed(0)
            odds_total = (odds_total_original * key_percent_original) / newkey

            await Promise.all(
              market.odds.map(async odd => {
                if (odd.active) {
                  const new_odd_value =
                    (odd.outcome_odd_percent * odds_total) / 100

                  let change = 'equal'
                  if (
                    parseFloat(new_odd_value.toFixed(2)) >
                    parseFloat(odd.outcome_odd_value_backup)
                  ) {
                    change = 'up'
                  } else if (
                    parseFloat(new_odd_value.toFixed(2)) <
                    parseFloat(odd.outcome_odd_value_backup)
                  ) {
                    change = 'down'
                  }

                  odd.type_change = change

                  odd.outcome_odd_value = new_odd_value.toFixed(2)
                  odd.outcome_odd_value_original = new_odd_value.toFixed(2)
                  odd.outcome_odd_value_for_order = parseFloat(
                    new_odd_value.toFixed(2)
                  )
                  odd.outcome_key_value = 100 / odd.outcome_odd_value
                  odd.outcome_key_value_original = 100 / odd.outcome_odd_value
                  odd.active =
                    parseFloat(new_odd_value) < 1.01 ? false : odd.active
                }
              })
            )
          } else {
            market.key_percent = keyPercent
            market.key_percent_original = keyPercent
            market.key_percent_fixed = parseFloat(keyPercent).toFixed(0)
            market.key_percent_fixed_original =
              parseFloat(keyPercent).toFixed(2)
            market.odds_total = odds_total
            market.odds_total_original = odds_total
          }
        }
      })
    )

    return oddsMarkets
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getEventMultiplicity(
  eventSource,
  rules,
  onlyManager,
  producer,
  market = 'all'
) {
  try {
    // Level Event
    const eventAllManagerMultiplicity = await filter(
      rules.manager,
      function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'event#' + producer &&
          rule.source == eventSource &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      }
    )

    if (!onlyManager) {
      var eventAllSkinMultiplicity = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'multiplicity' &&
          rule.scope == 'event#' + producer &&
          rule.source == eventSource &&
          rule.detail.market == market
        ) {
          return rule.detail.multiplicity
        }
      })
    }

    if (
      eventAllSkinMultiplicity != undefined &&
      eventAllSkinMultiplicity.length == 1
    ) {
      return eventAllSkinMultiplicity[0].detail.multiplicity
    } else if (
      eventAllManagerMultiplicity != undefined &&
      eventAllManagerMultiplicity.length == 1
    ) {
      return eventAllManagerMultiplicity[0].detail.multiplicity
    } else {
      return undefined
    }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getTreeKey(
  tree_structure,
  rules,
  onlyManager,
  producer,
  market
) {
  try {
    let market_find = market
    if (market.includes('#')) {
      const split = market.split('#')
      market_find = split[0]
    }
    let treeKey = undefined

    // Level Sport
    const sportManagerKey = await filter(rules.manager, function (rule) {
      if (
        rule.type == 'key' &&
        rule.scope == 'sport#' + producer &&
        rule.source == tree_structure.sport &&
        rule.detail.market == market_find
      ) {
        return rule.detail.key
      }
    })

    if (!onlyManager) {
      var sportSkinKey = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'key' &&
          rule.scope == 'sport#' + producer &&
          rule.source == tree_structure.sport &&
          rule.detail.market == market_find
        ) {
          return rule.detail.key
        }
      })
    }

    // Level Category
    const categoryManagerKey = await filter(rules.manager, function (rule) {
      if (
        rule.type == 'key' &&
        rule.scope == 'category#' + producer &&
        rule.source == tree_structure.category &&
        rule.detail.market == market_find
      ) {
        return rule.detail.key
      }
    })

    if (!onlyManager) {
      var categorySkinKey = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'key' &&
          rule.scope == 'category#' + producer &&
          rule.source == tree_structure.category &&
          rule.detail.market == market_find
        ) {
          return rule.detail.key
        }
      })
    }

    // Level Tournament
    const tournamentManagerKey = await filter(rules.manager, function (rule) {
      if (
        rule.type == 'key' &&
        rule.scope == 'tournament#' + producer &&
        rule.source == tree_structure.tournament &&
        rule.detail.market == market_find
      ) {
        return rule.detail.key
      }
    })

    if (!onlyManager) {
      var tournamentSkinKey = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'key' &&
          rule.scope == 'tournament#' + producer &&
          rule.source == tree_structure.tournament &&
          rule.detail.market == market_find
        ) {
          return rule.detail.key
        }
      })
    }

    if (tournamentSkinKey != undefined && tournamentSkinKey.length == 1) {
      treeKey = tournamentSkinKey[0].detail.key
    } else if (
      tournamentManagerKey != undefined &&
      tournamentManagerKey.length == 1
    ) {
      treeKey = tournamentManagerKey[0].detail.key
    } else if (categorySkinKey != undefined && categorySkinKey.length == 1) {
      treeKey = categorySkinKey[0].detail.key
    } else if (
      categoryManagerKey != undefined &&
      categoryManagerKey.length == 1
    ) {
      treeKey = categoryManagerKey[0].detail.key
    } else if (sportSkinKey != undefined && sportSkinKey.length == 1) {
      treeKey = sportSkinKey[0].detail.key
    } else if (sportManagerKey != undefined && sportManagerKey.length == 1) {
      treeKey = sportManagerKey[0].detail.key
    }

    return treeKey
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getEventKey(eventSource, rules, onlyManager, producer, market) {
  try {
    let market_find = market
    if (market.includes('#')) {
      const split = market.split('#')
      market_find = split[0]
    }

    // Level Event
    const eventAllManagerKey = await filter(rules.manager, function (rule) {
      if (
        rule.type == 'key' &&
        rule.scope == 'event#' + producer &&
        rule.source == eventSource &&
        rule.detail.market == market_find
      ) {
        return rule.detail.key
      }
    })

    if (!onlyManager) {
      var eventAllSkinKey = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'key' &&
          rule.scope == 'event#' + producer &&
          rule.source == eventSource &&
          rule.detail.market == market_find
        ) {
          return rule.detail.key
        }
      })
    }

    if (eventAllSkinKey != undefined && eventAllSkinKey.length == 1) {
      return eventAllSkinKey[0].detail.key
    } else if (
      eventAllManagerKey != undefined &&
      eventAllManagerKey.length == 1
    ) {
      return eventAllManagerKey[0].detail.key
    } else {
      return undefined
    }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getEventFreeze(
  eventSource,
  rules,
  onlyManager,
  producer,
  market
) {
  try {
    // Level Event
    const eventAllManagerFreeze = await filter(rules.manager, function (rule) {
      if (
        rule.type == 'freeze' &&
        rule.scope == 'event#' + producer &&
        rule.source == eventSource &&
        rule.detail.market == market
      ) {
        return rule.detail.odds
      }
    })

    if (!onlyManager) {
      var eventAllSkinFreeze = await filter(rules.skin, function (rule) {
        if (
          rule.type == 'freeze' &&
          rule.scope == 'event#' + producer &&
          rule.source == eventSource &&
          rule.detail.market == market
        ) {
          return rule.detail.odds
        }
      })
    }

    if (eventAllSkinFreeze != undefined && eventAllSkinFreeze.length == 1) {
      return eventAllSkinFreeze[0].detail.odds
    } else if (
      eventAllManagerFreeze != undefined &&
      eventAllManagerFreeze.length == 1
    ) {
      return eventAllManagerFreeze[0].detail.odds
    } else {
      return undefined
    }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

// async function getInfoWithRules(element,skinsList, platformId, lang) {
//
//     try {
//
//         var manager = find(skinsList, {"platform_id": 0});
//
//         var desc_element = find(element.detail, { 'lang': lang});
//         if(!desc_element){
//             desc_element = find(element.detail, { 'lang': 'en'});
//         }
//         var element_obj = {
//             id : element.id,
//             source: element.source,
//             name: desc_element.text
//         }
//
//         const checkRulesSportManager = filter(manager.rules, {'source':element.source})
//         if(checkRulesSportManager.length > 0){
//             for(let rule of checkRulesSportManager){
//                 if(rule == "translation"){
//                     element_obj.name = rule.detail
//                 }
//             }
//         }
//
//         if(platformId > 0){
//             const checkRulesSportSkin = filter(find(skinsList, {"platform_id": platformId}).rules, {'source':element.source})
//             if(checkRulesSportSkin.length > 0){
//                 for(let rule of checkRulesSportSkin){
//                     if(rule == "translation"){
//                         element_obj.name = rule.detail
//                     }
//                 }
//             }
//         }
//
//         return element_obj;
//
//     }catch (e){
//         console.log(e.message)
//         console.log(e.stack)
//     }
//
//
// }

async function getCompetitorsWithRules(competitor, rules, lang) {
  try {
    const competitorObj = has(competitor, 'detail') ? competitor : 'n.d.'

    if (competitorObj != 'n.d.') {
      const competitorWithRules = await applyRules(
        competitor,
        rules,
        competitor.source
      )

      return await ge
    } else {
      return {
        id: 'n.d.',
        source: 'n.d.',
        name: 'n.d.',
      }
    }
  } catch (e) {
    console.log(e.message)
    console.log(e.stack)
  }
}

async function getStatusFromRule(source, rules, scope) {
  const rules_disabled = {
    manager:
      rules.manager.length > 0
        ? find(rules.manager[0].detail, { scope: scope, id: source })
        : undefined,
    skin:
      rules.skin.length > 0
        ? find(rules.skin[0].detail, { scope: scope, id: source })
        : undefined,
  }

  if (rules_disabled.manager == undefined && rules_disabled.skin == undefined) {
    return true
  } else {
    let status = true

    if (rules_disabled.manager) {
      status = !rules_disabled.manager.status
    }
    if (rules_disabled.skin) {
      status = !rules_disabled.skin.status
    }
    return status
  }
}

async function applyRulesToObject(element, rules, onlyManager, source) {
  return new Promise(async (resolve, reject) => {
    await applyRules(element, rules.manager, source)

    if (!onlyManager) {
      await applyRules(element, rules.skin, source)
    }

    resolve(element)
  })
}

async function applyTranslationToElement(element, lang) {
  if (element == null) {
    return
  }

  if (!element.detail) {
    return
  }

  try {
    const detail = element.detail

    let fallbackDesc_element = ''
    const desc_element = find(detail, { lang: lang })
    if (!desc_element) {
      fallbackDesc_element = find(detail, { lang: 'en' })
    }

    if (desc_element) {
      element.name = desc_element.text
    } else if (fallbackDesc_element) {
      console.log(
        'Fallback translation ! for element source: ' + element.source
      )
      element.name = fallbackDesc_element.text
    }
  } catch (e) {
    console.log('Errore trad. ' + element.source)
  }
}

export default {
  getDesc,
  applyRules,
  applyRulesToOdds,
  refreshOdds,
  getDefaultMultiplicity,
  getTreeMultiplicity,
  getCompetitorsWithRules,
  applyRulesToObject,
  applyTranslationToElement,
}
